/**
 * Saved-search seed data - the mock shopper's three hunts (CAT-06), matching
 * the account mockup verbatim.
 */
import { SavedSearchState } from '@core/models/saved-search.state';
import { AlertChannel } from '@core/models/shopper.enum';

import { daysAgo } from '../seed-time';

export const seedSavedSearches = (): SavedSearchState[] => [
  {
    id: 1,
    shopperId: 1,
    title: "Levi's Type III trucker jacket · size M",
    criteriaLabel: 'Any condition · within 10 mi of Los Angeles 90012 · alerts: text + email',
    query: { q: "levi's type III trucker jacket", categorySlug: 'clothing', conditionMin: null, maxDistanceMi: 10 },
    alertChannel: AlertChannel.EmailAndText,
    newMatchCount: 2,
    icon: 'shirt',
    createdAt: daysAgo(30)
  },
  {
    id: 2,
    shopperId: 1,
    title: 'Vintage Pyrex - Butterprint or Gooseberry',
    criteriaLabel: 'Excellent or better · within 25 mi · alerts: text',
    query: { q: 'vintage pyrex', categorySlug: 'kitchen-dining', conditionMin: 2, maxDistanceMi: 25 },
    alertChannel: AlertChannel.Text,
    newMatchCount: 1,
    icon: 'pot',
    createdAt: daysAgo(14)
  },
  {
    id: 3,
    shopperId: 1,
    title: 'Canon film camera · AE-1 or A-1',
    criteriaLabel: 'Working condition · any distance · alerts: email',
    query: { q: 'canon film camera', categorySlug: 'electronics', conditionMin: null, maxDistanceMi: null },
    alertChannel: AlertChannel.Email,
    newMatchCount: 0,
    icon: 'camera',
    createdAt: daysAgo(7)
  }
];
